import { useEffect, useRef } from "react";

export default function CustomCursor() {
    const dotRef = useRef(null);
    const ringRef = useRef(null);

    useEffect(() => {
        // Disable on touch / fine-pointer-less devices AND on smaller screens
        // (mobile / tablet) — heavy and not useful there.
        if (
            window.matchMedia("(hover: none)").matches ||
            window.matchMedia("(max-width: 1024px)").matches ||
            window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ) {
            return;
        }

        const dot = dotRef.current;
        const ring = ringRef.current;
        if (!dot || !ring) return;

        let mouseX = 0,
            mouseY = 0;
        let ringX = 0,
            ringY = 0;
        let rafId = null;
        let pending = false;

        const onMove = (e) => {
            mouseX = e.clientX;
            mouseY = e.clientY;
            dot.style.transform = `translate(${mouseX}px, ${mouseY}px) translate(-50%, -50%)`;
            if (!pending) {
                pending = true;
                rafId = requestAnimationFrame(animate);
            }
        };

        const animate = () => {
            ringX += (mouseX - ringX) * 0.22;
            ringY += (mouseY - ringY) * 0.22;
            ring.style.transform = `translate(${ringX}px, ${ringY}px) translate(-50%, -50%)`;
            // Stop the rAF loop once we've practically reached the target —
            // prevents an infinite loop that hammers the GPU when the mouse
            // is idle.
            if (
                Math.abs(mouseX - ringX) < 0.5 &&
                Math.abs(mouseY - ringY) < 0.5
            ) {
                pending = false;
                return;
            }
            rafId = requestAnimationFrame(animate);
        };

        const onEnter = (e) => {
            ring.classList.add("is-hover");
            if (e.currentTarget.dataset?.cursorDark === "true") {
                ring.classList.add("is-hover-dark");
            }
        };
        const onLeave = () => {
            ring.classList.remove("is-hover");
            ring.classList.remove("is-hover-dark");
        };

        const interactive = document.querySelectorAll(
            "a, button, .photo-card, [data-cursor='hover'], [role='button']",
        );
        interactive.forEach((el) => {
            el.addEventListener("mouseenter", onEnter);
            el.addEventListener("mouseleave", onLeave);
        });

        window.addEventListener("mousemove", onMove, { passive: true });

        return () => {
            if (rafId) cancelAnimationFrame(rafId);
            window.removeEventListener("mousemove", onMove);
            interactive.forEach((el) => {
                el.removeEventListener("mouseenter", onEnter);
                el.removeEventListener("mouseleave", onLeave);
            });
        };
    }, []);

    return (
        <>
            <div ref={ringRef} className="cursor-ring" aria-hidden="true" />
            <div ref={dotRef} className="cursor-dot" aria-hidden="true" />
        </>
    );
}
